// @vendors
const get = require('lodash/object/get');
// @constants
const actionTypes = require('constants/contactCenter/actionTypes');
// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
// @constants
const ACCOUNT_PRECAUTIONARY_WARNINGS = require('constants/contactCenter/accountPrecautionaryWarnings');

const requestPrecautionaryWarningsFromAccount = () => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_REQUEST
});

const requestPrecautionaryWarningsSuccess = (response) => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_SUCCESS,
    payload: {
        data: get(response, 'icAvisos.kcAvisos', []),
        group: get(response, 'repos.agrupa'),
        endList: response.finLista
    }
});

const requestPrecautionaryWarningsFailure = (error) => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_FAILURE,
    payload: {
        error
    }
});

const requestPrecautionaryWarnings = accountId => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immAccountPrecautionaryWarnings = getState().accountPrecautionaryWarnings;
    const params = {
        query: {
            producto: immAccount.get('newProduct'),
            numeroContrato: immAccount.get('newContractNumber'),
            indicadorListaRepos: ACCOUNT_PRECAUTIONARY_WARNINGS.REPOS_LIST_INDICATOR,
            agrupa: immAccountPrecautionaryWarnings.get('group'),
            codCircuitoAviso: ACCOUNT_PRECAUTIONARY_WARNINGS.NOTICE_CIRCUIT_CODE
        }
    }

    dispatch(requestPrecautionaryWarningsFromAccount());
    return APIGet({dispatch, endpoint: 'precautionaryWarnings', params})
        .then(response => dispatch(requestPrecautionaryWarningsSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestPrecautionaryWarningsFailure(response.error));
            } else {
                throw response;
            }
        });
};

const requestPrecautionaryWarningsFromAccountNextPage = () => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_REQUEST_NEXT_PAGE
});

const requestPrecautionaryWarningsSuccessNextPage = (response) => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_SUCCESS_NEXT_PAGE,
    payload: {
        data: get(response, 'icAvisos.kcAvisos', []),
        group: get(response, 'repos.agrupa'),
        endList: response.finLista
    }
});

const requestPrecautionaryWarningsFailureNextPage = (error) => ({
    type: actionTypes.ACCOUNTS_PRECAUTIONARY_WARNINGS_FAILURE_NEXT_PAGE,
    payload: {
        error
    }
});

const requestPrecautionaryWarningsNextPage = accountId => (dispatch, getState) => {
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immAccountPrecautionaryWarnings = getState().accountPrecautionaryWarnings;
    const params = {
        query: {
            producto: immAccount.get('newProduct'),
            numeroContrato: immAccount.get('newContractNumber'),
            indicadorListaRepos: ACCOUNT_PRECAUTIONARY_WARNINGS.NEXT_PAGE_INDICATOR,
            agrupa: immAccountPrecautionaryWarnings.get('group'),
            codCircuitoAviso: ACCOUNT_PRECAUTIONARY_WARNINGS.NOTICE_CIRCUIT_CODE
        }
    }

    dispatch(requestPrecautionaryWarningsFromAccountNextPage());
    return APIGet({dispatch, endpoint: 'precautionaryWarnings', params})
        .then(response => dispatch(requestPrecautionaryWarningsSuccessNextPage(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestPrecautionaryWarningsFailureNextPage(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    requestPrecautionaryWarnings,
    requestPrecautionaryWarningsNextPage
}
